<template>
  <div>
    <!-- 矩阵添加 -->
    <Form
      ref="addForm"
      :model="addForm"
      :label-width="150"
      label-colon
      :rules="ruleValidateType3"
    >
      <!-- 所属上级区域 -->
      <FormItem
        v-if="addForm.namePath"
        :label="$t('deviceSip.prevArea')"
        prop="namePath"
        required
      >
        <Input
          v-model="addForm.namePath"
          size="large"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 5 }"
          clearable
          disabled
        />
      </FormItem>
      <!-- 区域名称前缀 -->
      <FormItem :label="$t('area.areaNameTop')" prop="nameTop">
        <Input
          v-model="addForm.nameTop"
          size="large"
          :maxlength="20"
          :placeholder="$t('area.areaJoinHold')"
          clearable
        />
      </FormItem>
      <!-- 区域名称后缀 -->
      <FormItem :label="$t('area.areaNameLast')" prop="nameLast">
        <Input
          v-model="addForm.nameLast"
          size="large"
          :maxlength="20"
          :placeholder="$t('area.areaJoinHold1')"
          clearable
        />
      </FormItem>
      <!-- 首部起始编号 -->
      <FormItem prop="topStart" :label="$t('area.topStart')">
        <Input
          v-model="addForm.topStart"
          size="large"
          :maxlength="2"
          :placeholder="$t('area.topTip')"
          clearable
        />
      </FormItem>
      <!-- 首部结束编号 -->
      <FormItem prop="topEnd" :label="$t('area.topEnd')">
        <Input
          v-model="addForm.topEnd"
          size="large"
          :maxlength="2"
          :placeholder="$t('area.topTip')"
          clearable
        />
      </FormItem>
      <!-- 尾部起始编号 -->
      <FormItem prop="lastStart" :label="$t('area.lastStart')">
        <Input
          v-model="addForm.lastStart"
          size="large"
          :maxlength="2"
          :placeholder="$t('area.lastTip')"
          clearable
        />
      </FormItem>
      <!-- 尾部结束编号 -->
      <FormItem prop="lastEnd" :label="$t('area.lastEnd')">
        <Input
          v-model="addForm.lastEnd"
          size="large"
          :maxlength="2"
          :placeholder="$t('area.lastTip')"
          clearable
        />
      </FormItem>
      <!-- 群呼 -->
      <FormItem prop="groupCall">
        <span slot="label">
          <span class="error-color">*</span>
          {{ $t("updateNewSip.groupCall") }}
        </span>
        <i-switch
          v-model="addForm.groupCall"
          :true-value="1"
          :false-value="0"
          size="large"
          class="margin-right-10"
        />
        <Poptip
          trigger="hover"
          :title="$t('deviceSip.note')"
          placement="right-top"
        >
          <template #content>
            <h4 class="call-tip-box">
              {{ $t("updateNewSip.groupCallTip") }}
            </h4>
          </template>
          <Icon type="md-help-circle" size="24" color="#FFB22B" />
        </Poptip>
      </FormItem>
      <!-- 示例 -->
      <FormItem
        v-show="
          (addForm.nameTop || addForm.nameLast) &&
          addForm.topStart &&
          addForm.lastStart
        "
        :label="$t('area.areaNameTest')"
      >
        <span style="color: #ed4014">{{
          addForm.nameTop +
          addForm.topStart +
          (Number(addForm.lastStart) > 9
            ? Number(addForm.lastStart)
            : "0" + Number(addForm.lastStart)) +
          addForm.nameLast
        }}</span>
      </FormItem>
    </Form>
    <div class="detailBackBtn">
      <Button size="large" @click="closeModal">{{
        $t("common.cancel")
      }}</Button>

      <Button
        v-debounce
        type="primary"
        size="large"
        :loading="spinShow"
        @click="handleSubmit"
      >
        {{ $t("common.ensure") }}
      </Button>
    </div>

    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal
        ref="resultModal"
        :type="modalType"
        @afterComfirm="closeModal"
      ></modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAllParentNode } from "@/utils/tree";

export default {
  name: "ModalBox",
  props: {
    currentNode: {
      // 左侧树选中的节点信息
      type: Object,
      default() {
        return {};
      },
    },
    spinShow: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      addForm: {
        nameTop: "",
        nameLast: "",
        topStart: "",
        lastStart: "",
        topEnd: "",
        lastEnd: "",
        namePath: "",
        groupCall: 0,
      },
      modalType: false,
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "ruleValidateType3",
      "allAreaNum",
    ]),
  },
  watch: {},
  mounted() {
    console.log("type3的操作时间：：" + new Date());
    this.setNamePath();
  },
  methods: {
    // 清除选中
    clearForm() {
      this.addForm = {
        nameTop: "",
        nameLast: "",
        topStart: "",
        lastStart: "",
        topEnd: "",
        lastEnd: "",
        namePath: "",
        groupCall: 0,
      };
      this.$refs.addForm.resetFields();
    },
    closeModal() {
      this.clearForm();
      this.$emit("closeBox");
    },
    // 提交方法
    handleSubmit() {
      this.$emit("changeSpinShow", true);

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 比较首部开始编号和首部结束编号
          if (Number(this.addForm.topStart) > Number(this.addForm.topEnd)) {
            this.$Message.error(this.$t("deviceSip.areaNoTip1"));
            this.$emit("changeSpinShow", false);
            return;
          }
          // 比较首部开始编号和首部结束编号
          if (Number(this.addForm.lastStart) > Number(this.addForm.lastEnd)) {
            this.$Message.error(this.$t("deviceSip.areaNoTip2"));
            this.$emit("changeSpinShow", false);
            return;
          }

          this.changeArea();
        } else {
          this.$emit("changeSpinShow", false);
        }
      });
    },
    // 新增区域
    changeArea() {
      if (this.currentNode.code) {
        // 选中父区域

        this.setDeepArrData(
          this.areaDeviceData,
          this.currentNode["$treeNodeId"],
          "$treeNodeId",
          "groupList",
          "name"
        );
      } else {
        // 选中首层区域，即无当前选中的节点
        let targetArray = this.getArray(1, null);
        // 判断区域上限
        if (!this.checkAreaNum(targetArray.length)) {
          this.$emit("changeSpinShow", false);
          return;
        }

        // 重复code判断
        let isRepeatCode = this.checkAreaRepeat(
          this.areaDeviceData.concat(targetArray),
          "code"
        );

        if (!isRepeatCode) {
          this.$emit("changeSpinShow", false);
          return;
        }

        targetArray.forEach((item) => {
          item.namePath = item.name;
        });
        let areaDeviceData = this.areaDeviceData.concat(targetArray);
        // 区域、设备名称排序  按字符串排序
        areaDeviceData = areaDeviceData.sort((a, b) => {
          return a.code - b.code;
        });
        // 添加成功，关闭弹窗
        this.$emit("changeSpinShow", false);
        this.$refs.resultModal.dialogVisible = true;
        this.modalType = true;
        this.$store.commit("projectConfig/SET_AREADEVICEDATA", areaDeviceData);
      }

      // 更新树组件的渲染
      this.$emit("updateTree");
    },

    // 递归查找选中的区域，然后增加矩阵添加的节点
    setDeepArrData(
      arr,
      id,
      idStr = "$treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (item[idStr] === id) {
          // 遍历

          // 判断是否为最小层级，不能继续添加子节点
          let commLevel = Number(localStorage.getItem("commLevel"));
          if (commLevel === item.level) {
            this.$Message.error(this.$t("deviceSip.smallAreaTip"));
            this.$emit("changeSpinShow", false);
            return;
          }

          let level = item.level + 1;
          // 连续新增
          let targetArray = this.getArray(level, this.currentNode.codePath);
          // 判断区域上限
          if (!this.checkAreaNum(targetArray.length)) {
            this.$emit("changeSpinShow", false);
            return;
          }

          // 重复code判断
          let isRepeatCode = this.checkAreaRepeat(
            item.groupList.concat(targetArray),
            "code"
          );

          if (!isRepeatCode) {
            this.$emit("changeSpinShow", false);
            return;
          }

          if (item.hasSubGroup === 0 || !item.hasSubGroup) {
            item.hasSubGroup = 1;
            item.groupList = [];
          }
          if (Array.isArray(item[child])) {
            item.groupList = item.groupList.concat(targetArray);
            // 区域、设备名称排序  按字符串排序
            item.groupList = item.groupList.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          }

          // 添加成功，关闭弹窗
          this.$emit("changeSpinShow", false);
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
          this.$store.commit(
            "projectConfig/SET_AREADEVICEDATA",
            this.areaDeviceData
          );
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrData(item[child], id, idStr, child, name);
        }
      }
    },

    // 矩阵数据
    // level 层级   fatherCodePath 父节点codepath
    getArray(level, fatherCodePath) {
      let targetArray = []; // 目标数组
      for (
        let i = Number(this.addForm.topStart);
        i <= Number(this.addForm.topEnd);
        i++
      ) {
        for (
          let j = Number(this.addForm.lastStart);
          j <= Number(this.addForm.lastEnd);
          j++
        ) {
          let name =
            this.addForm.nameTop +
            i +
            (Number(j) > 9 ? String(j) : "0" + Number(j)) +
            this.addForm.nameLast;

          let code = i + (Number(j) > 9 ? String(j) : "0" + Number(j));
          let codePath = fatherCodePath ? fatherCodePath + "-" + code : code;

          let obj = {
            name: name,
            code: code,
            codePath: codePath,
            children: [],
            groupList: [],
            level: level,
            expand: true,
            groupCall: this.addForm.groupCall,
          };
          targetArray.push(obj);
        }
      }

      return targetArray;
    },
    setNamePath() {
      if (!this.currentNode.code) {
        // 无选中的点
        this.addForm.namePath = "";
      } else {
        // 自己找祖先节点
        let allParentNodeArray = getAllParentNode(
          this.areaDeviceData,
          this.currentNode["$treeNodeId"]
        );

        // 倒转，按远到近排
        allParentNodeArray = allParentNodeArray.reverse();

        allParentNodeArray = allParentNodeArray.map((item) => {
          return item.name;
        });
        allParentNodeArray.push(this.currentNode.name);

        this.addForm.namePath = allParentNodeArray.join("-");
      }
      return this.addForm.namePath;
    },
    /**
     * 判断同个层级的区域编号、区域名称是否重复
     * array:目标数组
     * key：键值
     */
    checkAreaRepeat(array, key) {
      let returnBoolean = true;
      let arrayCodeList = array.map((item) => {
        return Number(item[key]);
      });
      let arrayNameList = array.map((item) => {
        return item.name;
      });
      // 过滤重复编号
      arrayCodeList = [...new Set(arrayCodeList)];
      // 过滤重复名称
      arrayNameList = [...new Set(arrayNameList)];

      // 判断重复编号
      if (array.length !== arrayCodeList.length) {
        returnBoolean = false;
        this.$Message.error(this.$t("updateNewSip.codeRepeatTip"));
        return returnBoolean;
      }
      // 判断重复名称
      if (array.length !== arrayNameList.length) {
        returnBoolean = false;
        this.$Message.error(this.$t("updateNewSip.nameRepeatTip"));
      }

      return returnBoolean;
    },
    // 区域所有节点10000个的限制
    checkAreaNum(addNum, maxNum = 10000) {
      let isNext = true;
      // 判断区域是否超出上限
      if (this.allAreaNum + addNum > maxNum) {
        this.$Message.error(this.$t("updateNewSip.areaMax"));
        isNext = false;
      }
      return isNext;
    },
  },
};
</script>
